import {
  faChartLine,
  faExclamationTriangle,
  faEye,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleModal from "app/components/Modals/SimpleModal";
import Button from "app/storybookComponents/Button";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onConfirm: () => void;
}

const WeeklyCheckInVisibilityWarningModal = ({
  isOpen,
  onClose,
  isLoading,
  onConfirm,
}: Props) => {
  return (
    <SimpleModal show={isOpen} onHide={onClose}>
      <div className="-mt-[50px] d-flex align-items-center gap-2">
        <div className="d-flex h-12 w-12 bg-sapphire-10 text-sapphire-100 rounded-xl align-items-center justify-content-center">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-2xl" />
        </div>
        <h2>Switch to Open Mode?</h2>
      </div>
      <p>
        This will make numerical check-in scores visible to{" "}
        <b>all admins and managers</b> across your organization. This change
        applies immediately and includes historical data.
      </p>

      <div className="flex flex-col gap-2 px-4 py-3 bg-charcoal-05 rounded-lg border-[1px] border-charcoal-20 text-charcoal-130">
        <div className="d-flex gap-2">
          <FontAwesomeIcon icon={faEye} className="text-sapphire-100" />
          <p>
            Individual mood, progress, and readiness scores will be visible in
            the Responses table and detail panels
          </p>
        </div>
        <div className="d-flex gap-2">
          <FontAwesomeIcon icon={faChartLine} className="text-sapphire-100" />
          <p>
            Score trend charts and engagement indicators (Check Up / Follow Up)
            will appear on the Dashboard
          </p>
        </div>
        <div className="d-flex gap-2">
          <FontAwesomeIcon icon={faUsers} className="text-sapphire-100" />
          <p>
            Celebrate & Support cards will show magnitude and severity scores
          </p>
        </div>
      </div>

      <p>
        If your organization values privacy or is building trust with check-ins,
        consider staying in Conservative mode.
      </p>
      <div className="d-flex w-full">
        <div className="d-flex gap-2 ms-auto">
          <Button
            variant="secondary-gray"
            disabled={isLoading}
            onClick={onClose}
          >
            Stay in Conservative
          </Button>
          <Button disabled={isLoading} onClick={onConfirm}>
            Switch to Open Mode
          </Button>
        </div>
      </div>
    </SimpleModal>
  );
};

export default WeeklyCheckInVisibilityWarningModal;
